import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatatableService } from '../../../shared/services/datatable.service';
import { Router } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { IMyDpOptions } from 'mydatepicker';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExtratoReusoAutomaticoService } from './extrato-reuso-automatico.service';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';


@Component({
  selector: 'ngx-extrato-reuso-automatico',
  templateUrl: './extrato-reuso-automatico.component.html',
  styleUrls: ['./extrato-reuso-automatico.component.scss']
})
export class ExtratoReusoAutomaticoComponent implements OnInit {

  @ViewChild('myTable', { static: false })
  public myTable: DatatableComponent;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  public formExtratoReusoAutomatico = null;
  public cnpjCpf = null;
  public listReuso = null;
  public tableLimit = 12;
  public rowData: any;
  public columnsTabe = null;
  public customLogin = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
  };

  constructor(
    private formBuilder: FormBuilder,
    private datatableService: DatatableService,
    private router: Router,
    private dateUtilService: DateUtilService,
    private paginationService: SpringDatatablePaginationService,
    private notifications: NotificationsService,
    private service: ExtratoReusoAutomaticoService,
    private spinnerService: NgxSpinnerService,
    private exportCsvService: ExportCsvService,

  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listReuso = [

      {
        status: 'VALOR',
        descricao: 'VALOR'
      },

      {
        status: 'PERCENTUAL',
        descricao: 'PERCENTUAL'
      },

    ];

    this.columnsTabe = [
      { columnName: "tipoReuso", newColumnName: "Tipo Reuso" },
      { columnName: "statusPedidoVenda", newColumnName: "Status" },
      { columnName: "valorReuso", newColumnName: "Valor" },
      { columnName: "dataCadastro", newColumnName: "Data Cadastro" },
      { columnName: "numeroPedidoId", newColumnName: "Numero Pedido" },
      { columnName: "detalheCompraNegada", newColumnName: "Detalhe Compra Negada" },
      { columnName: "cnpjReuso", newColumnName: "CNPJ Reuso" },
      { columnName: "dataCadastroReuso", newColumnName: "data Cadastro Reuso" },
      { columnName: "dataInicioContratoReuso", newColumnName: "Data Inicio Reuso" },
      { columnName: "emailReuso", newColumnName: "Email Reuso" },
      { columnName: "etapaIntegracaoReuso", newColumnName: "Etapa Integracao Reuso" },
      { columnName: "etapaIntegracaoCartaoReuso", newColumnName: "Etapa Integracao Cartao Reuso" },
      { columnName: "etapaIntegracaoContaReuso", newColumnName: "Etapa Integracao Conta Reuso" },
      { columnName: "etapaIntegracaoContatoReuso", newColumnName: "Etapa Integracao Contato Reuso" },
      { columnName: "etapaIntegracaoEnderecoReuso", newColumnName: "Etapa Integracao Endereco Reuso" },
      { columnName: "exclusividade", newColumnName: "Exclusividade" },
      { columnName: "idReuso", newColumnName: "Id Reuso" },
      { columnName: "industriaReuso", newColumnName: "Industria Reuso" },
      { columnName: "inscricaoEstadualReuso", newColumnName: "Inscricao Estadual Reuso" },
      { columnName: "nomeFantasiaReuso", newColumnName: "Nome Fantasia Reuso" },
      { columnName: "processadoraIdReuso", newColumnName: "ProcessadoraId Reuso" },
      { columnName: "processadoraStatusReuso", newColumnName: "Processadora Status Reuso" },
      { columnName: "razaoSocialReuso", newColumnName: "Razao Social Reuso" },
      { columnName: "statusReuso", newColumnName: "Status Reuso" },
      { columnName: "telefoneComercialReuso", newColumnName: "Telefone Comercial Reuso" },
      { columnName: "ultimaAtualizacaoReuso", newColumnName: "Ultima Atualizacao Reuso" },
      { columnName: "adcLancamentoId", newColumnName: "ADC Lancamento" },
      { columnName: "dataLancamentoRegistro", newColumnName: "Data Lancamento Registro" },
      { columnName: "dataLancamentoTransacao", newColumnName: "Data Lancamento Transacao" },
      { columnName: "idLancamento", newColumnName: "ID Lancamento" },
      { columnName: "statusLancamentoProcessamento", newColumnName: "Status Lancamento" },
      { columnName: "valorLancamentoTransacao", newColumnName: "Valor Lancamento Transacao" },
      { columnName: "cnpj", newColumnName: "CNPJ Empresa" },
      { columnName: "dataCadastroEmpresa", newColumnName: "Data Cadastro Empresa" },
      { columnName: "dataInicioContrato", newColumnName: "Data Inicio Contrato" },
      { columnName: "email", newColumnName: "Email" },
      { columnName: "etapaIntegracao", newColumnName: "Etapa Integracao" },
      { columnName: "etapaIntegracaoCartao", newColumnName: "Etapa Integracao Cartao" },
      { columnName: "etapaIntegracaoConta", newColumnName: "Etapa Integracao Conta" },
      { columnName: "etapaIntegracaoContato", newColumnName: "Etapa Integracao Contato" },
      { columnName: "etapaIntegracaoEndereco", newColumnName: "Etapa Integracao Endereco" },
      { columnName: "exclusividadeEmpresa", newColumnName: "Exclusividade Empresa" },
      { columnName: "id", newColumnName: "ID" },
      { columnName: "industria", newColumnName: "Industria" },
      { columnName: "inscricaoEstadual", newColumnName: "Inscricao Estadual" },
      { columnName: "nomeFantasia", newColumnName: "Nome Fantasia" },
      { columnName: "processadoraId", newColumnName: "ProcessadoraId" },
      { columnName: "processadoraStatus", newColumnName: "processadoraStatus" },
      { columnName: "razaoSocial", newColumnName: "Razao Social" },
      { columnName: "statusEmpresa", newColumnName: "Status Empresa" },
      { columnName: "telefoneComercial", newColumnName: "Telefone Comercial" },
      { columnName: "ultimaAtualizacao", newColumnName: "Ultima Atualizacao" },

    ]

  }

  getCpfCnpjMask(): string {
    const ctrl = this.formExtratoReusoAutomatico && this.formExtratoReusoAutomatico.get('cnpjCpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjCpf != null && String(this.cnpjCpf).trim() !== ''
        ? this.cnpjCpf
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formExtratoReusoAutomatico = this.formBuilder.group({

      cnpjCpf: [null],
      dataInicio: [null],
      dataFim: [null],
      tipoReuso: [null],
      valor: [null],

    });
  }

  pesquisaReuso(data: any, page?: any) {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))

    if (page && page != null) {
      params = params.append('page', page);
    }

    const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    if (docNorm !== '') {
      params = params.append('cpfCnpj', docNorm);
    }
    if (data.dataInicio != null) {
      let dataInicio: any = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio', dataInicio)
    }
    if (data.dataFim != null) {
      let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim)
    }
    if (data.tipoReuso != null) {
      params = params.append('tipo', data.tipoReuso)
    }
    if (data.valor != null) {
      params = params.append('valor', data.valor)
    }

    this.spinnerService.show();

    this.service.extratoReuso(params, (response => {

      this.rowData = response.content
      this.rowData = this.rowData.map((data) => {
        return {
          cnpj: data.empresaReuso.cnpj,
          razaoSocial: data.empresaReuso.razaoSocial,
          dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY'),
          detalheCompraNegada: data.detalheCompraNegada,
          valorReuso: data.valorReuso,
          statusPedidoVenda: data.statusPedidoVenda,
          tipoReuso: data.tipoReuso,
        }

      });

      this.spinnerService.hide();
      this.paginationService.setInfo(response);

    }), (error) => {
      this.notifications.error(error.message);
      this.spinnerService.hide();
    });

  }

  exportarXlsx(data?: any) {

    let params = new HttpParams();

    const docNorm = this.normalizarCnpjCpfParaBackend(data && data.cnpjCpf);
    if (docNorm !== '') {
      params = params.append('cpfCnpj', docNorm);
    }
    if (data.dataInicio != null) {
      let dataInicio: any = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
      params = params.append('dataInicio', dataInicio)
    }
    if (data.dataFim != null) {
      let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
      params = params.append('dataFim', dataFim)
    }
    if (data.tipoReuso != null) {
      params = params.append('tipo', data.tipoReuso)
    }
    if (data.valor != null) {
      params = params.append('valor', data.valor)
    }

    this.spinnerService.show();

    this.service.extratoReuso(params, (response => {

      this.rowData = response.content
      this.rowData = this.rowData.map((data) => {
        return {

          tipoReuso: data.tipoReuso,
          valorReuso: data.valorReuso,
          dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY'),
          statusPedidoVenda: data.statusPedidoVenda,
          numeroPedidoId: data.numeroPedidoId,
          detalheCompraNegada: data.detalheCompraNegada,
          cnpjReuso: data.empresaReuso.cnpj,
          dataCadastroReuso: moment(data.empresaReuso.dataCadastro).format('DD/MM/YYYY'),
          dataInicioContratoReuso: moment(data.empresaReuso.dataInicioContrato).format('DD/MM/YYYY'),
          emailReuso: data.empresaReuso.email,
          etapaIntegracaoReuso: data.empresaReuso.etapaIntegracao,
          etapaIntegracaoCartaoReuso: data.empresaReuso.etapaIntegracaoCartao,
          etapaIntegracaoContaReuso: data.empresaReuso.etapaIntegracaoConta,
          etapaIntegracaoContatoReuso: data.empresaReuso.etapaIntegracaoContato,
          etapaIntegracaoEnderecoReuso: data.empresaReuso.etapaIntegracaoEndereco,
          exclusividade: data.empresaReuso.exclusividade,
          idReuso: data.empresaReuso.id,
          industriaReuso: data.empresaReuso.industria,
          inscricaoEstadualReuso: data.empresaReuso.inscricaoEstadual,
          nomeFantasiaReuso: data.empresaReuso.nomeFantasia,
          processadoraIdReuso: data.empresaReuso.processadoraId,
          processadoraStatusReuso: data.empresaReuso.processadoraStatus,
          razaoSocialReuso: data.empresaReuso.razaoSocial,
          statusReuso: data.empresaReuso.status,
          telefoneComercialReuso: data.empresaReuso.telefoneComercial,
          ultimaAtualizacaoReuso: moment(data.empresaReuso.ultimaAtualizacao).format('DD/MM/YYYY'),
          adcLancamentoId: data.lancamentoReuso.adcLancamentoId,
          dataLancamentoRegistro: data.lancamentoReuso.dataRegistro,
          dataLancamentoTransacao: data.lancamentoReuso.dataTransacao,
          idLancamento: data.lancamentoReuso.id,
          statusLancamentoProcessamento: data.lancamentoReuso.statusProcessamento,
          valorLancamentoTransacao: data.lancamentoReuso.valorTransacao,
          cnpj: data.lancamentoReuso.empresa.cnpj,
          dataCadastroEmpresa: moment(data.lancamentoReuso.empresa.dataCadastro).format('DD/MM/YYYY'),
          dataInicioContrato: moment(data.lancamentoReuso.empresa.dataInicioContrato).format('DD/MM/YYYY'),
          email: data.lancamentoReuso.empresa.email,
          etapaIntegracao: data.lancamentoReuso.empresa.etapaIntegracao,
          etapaIntegracaoCartao: data.lancamentoReuso.empresa.etapaIntegracaoCartao,
          etapaIntegracaoConta: data.lancamentoReuso.empresa.etapaIntegracaoConta,
          etapaIntegracaoContato: data.lancamentoReuso.empresa.etapaIntegracaoContato,
          etapaIntegracaoEndereco: data.lancamentoReuso.empresa.etapaIntegracaoEndereco,
          exclusividadeEmpresa: data.lancamentoReuso.empresa.exclusividade,
          id: data.lancamentoReuso.empresa.id,
          industria: data.lancamentoReuso.empresa.industria,
          inscricaoEstadual: data.lancamentoReuso.empresa.inscricaoEstadual,
          nomeFantasia: data.lancamentoReuso.empresa.nomeFantasia,
          processadoraId: data.lancamentoReuso.empresa.processadoraId,
          processadoraStatus: data.lancamentoReuso.empresa.processadoraStatus,
          razaoSocial: data.lancamentoReuso.empresa.razaoSocial,
          statusEmpresa: data.lancamentoReuso.empresa.status,
          telefoneComercial: data.lancamentoReuso.empresa.telefoneComercial,
          ultimaAtualizacao: moment(data.lancamentoReuso.empresa.ultimaAtualizacao).format('DD/MM/YYYY'),


        }

      });

      this.spinnerService.hide();
      this.exportCsvService.exportCsv(this.rowData, this.columnsTabe, ';', 'extratoReusoAutomatico');
    }), (error) => {
      this.notifications.error(error.message);
      this.spinnerService.hide();
    });

  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      this.formExtratoReusoAutomatico.controls['valor'].setValue(null);
      this.notifications.error('Não é permitido números negativos!');

    }
    return true;

  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '' || str === 'null') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
